'use strict';

const $ = window.jQuery;

export default function() {

    const $searchPopin = $( '#searchPopin' );
    const $searchInput = $( '#searchInput' );
    const $searchOpen = $( '#searchOpen' );
    const $searchClose = $( '#searchClose' );

    let prevFocus = null;

    const close = () => {
        $searchPopin.removeClass( 'is-active' );
        $searchInput.blur();
        if ( prevFocus ) {
            prevFocus.focus();
        }
    };

    // Open
    $searchOpen.on( 'click', function() {
        prevFocus = document.activeElement ?? null;
        $searchPopin.addClass( 'is-active' );
        $searchInput.focus();
    } );

    // Close
    $searchClose.on( 'click', function() {
        close();
    } );

    // Close when pressing escape
    $( document ).keyup( ( e ) => {
        if ( e.key === 'Escape' ) {
            close();
        }
    } );
};
